import React, { useEffect, useState } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useDeviceAuth } from '../../context/DeviceAuthContext';
import Loading from '../Common/Loading';
import PortraitLoading from '../Common/PortraitLoading';

interface DeviceProtectedRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const DeviceProtectedRoute: React.FC<DeviceProtectedRouteProps> = ({ component: Component, ...rest }) => {
  const { isDeviceAuthorized, loading } = useDeviceAuth();
  const [is22InchPortrait, setIs22InchPortrait] = useState(false);
  
  useEffect(() => {
    // Check if this is a 22-inch portrait display
    const check22InchPortrait = () => {
      return (window.screen.width === 1080 && window.screen.height === 1920) ||
             (window.innerWidth === 1080 && window.innerHeight === 1920);
    };
    
    setIs22InchPortrait(check22InchPortrait());
    
    const handleResize = () => {
      setIs22InchPortrait(check22InchPortrait());
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  // Show loading indicator while checking
  if (loading) {
    return is22InchPortrait ? (
      <PortraitLoading message="Checking device authorization..." />
    ) : (
      <Loading message="Checking device authorization..." />
    );
  }
  
  return (
    <Route
      {...rest}
      render={(props) =>
        isDeviceAuthorized ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/box",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default DeviceProtectedRoute;